__turbopack_context__.v({
  "addSecondaryPagesLink": "AddNewSourcePage-module-scss-module__z1IEDq__addSecondaryPagesLink",
  "blocksBackgroundColor": "AddNewSourcePage-module-scss-module__z1IEDq__blocksBackgroundColor",
  "blocksFontColor": "AddNewSourcePage-module-scss-module__z1IEDq__blocksFontColor",
  "colorPicker": "AddNewSourcePage-module-scss-module__z1IEDq__colorPicker",
  "currentOrgIndicator": "AddNewSourcePage-module-scss-module__z1IEDq__currentOrgIndicator",
  "editSecondaryPagesLink": "AddNewSourcePage-module-scss-module__z1IEDq__editSecondaryPagesLink",
  "helpText": "AddNewSourcePage-module-scss-module__z1IEDq__helpText",
  "primaryLabel": "AddNewSourcePage-module-scss-module__z1IEDq__primaryLabel",
  "primaryLocation": "AddNewSourcePage-module-scss-module__z1IEDq__primaryLocation",
  "secondaryNavBackgroundColor": "AddNewSourcePage-module-scss-module__z1IEDq__secondaryNavBackgroundColor",
  "selectOrgButton": "AddNewSourcePage-module-scss-module__z1IEDq__selectOrgButton",
  "selectedOrg": "AddNewSourcePage-module-scss-module__z1IEDq__selectedOrg",
  "selectedOrgs": "AddNewSourcePage-module-scss-module__z1IEDq__selectedOrgs",
  "shareContainer": "AddNewSourcePage-module-scss-module__z1IEDq__shareContainer",
  "shareHeader": "AddNewSourcePage-module-scss-module__z1IEDq__shareHeader",
  "sharedLabel": "AddNewSourcePage-module-scss-module__z1IEDq__sharedLabel",
  "sharedLocations": "AddNewSourcePage-module-scss-module__z1IEDq__sharedLocations",
  "themeBackgroundColor": "AddNewSourcePage-module-scss-module__z1IEDq__themeBackgroundColor",
  "themeFontColor": "AddNewSourcePage-module-scss-module__z1IEDq__themeFontColor",
  "themeFontFamily": "AddNewSourcePage-module-scss-module__z1IEDq__themeFontFamily",
  "tooltip": "AddNewSourcePage-module-scss-module__z1IEDq__tooltip",
});
